<template>
    <div>
        <BreadCrumb></BreadCrumb>
        <h2>Vorlagenübersicht</h2>
        <TabList class="tab-list" :items="items" :active-item-name="activeItemName"></TabList>
        <transition name="fade" mode="out-in">
            <div v-if="loading" :key="0" class="loader">
                <dot-loader id="loader"></dot-loader>
            </div>
            <div v-else :key="1">
                <div class="spaces-filter-container">
                    <div class="top-bar-left">
                        <InputSearch placeholder="Suche" v-model="searchValue"></InputSearch>
                    </div>
                    <AdaButton title="NEUE VORLAGE" to="/templates/spaces/create" type="createButton"
                               icon="icon-add"></AdaButton>
                </div>
                <AdaDatatable class="listingTable" :columns="columns" :data="spaceTemplates" :show-search="false"
                              :size-of-page="10"
                              @rowClicked="cellClicked" :search-value="searchValue"
                              :save-sort-state="true" table-id="tSpacesTable"
                              :transformers="transformers">
                    <AdaButton style="width: 100%; height: 50px" title="NEUE VORLAGE ERSTELLEN" type="fullWidthButton"
                               to="/templates/spaces/create" icon="icon-add"></AdaButton>
                </AdaDatatable>
            </div>
        </transition>
        <Dialog v-if="spaceToDelete" :show-close-button="true" :show="showDeleteSpaceDialog"
                :has-backdrop="true"
                @close="deleteDialogClose">
            <div class="delete-container">
                <h4>Module löschen</h4>
                <div style="margin-bottom: 30px">
                    Soll der Space: <span style="font-weight: bold">{{this.spaceToDelete.name}}</span>
                    wirklich
                    gelöscht werden?
                </div>
                <AdaButton :loading="deletingTemplate" class="btn-delete" @click="deleteClicked" title="LÖSCHEN" type="createButton"></AdaButton>
            </div>
        </Dialog>
        <Dialog v-if="spaceToCopy" :show-close-button="true" :show="showCopySpaceDialog"
                :has-backdrop="true"
                @close="copyDialogClose">
            <div class="delete-container">
                <h4>Space kopieren</h4>
                <div style="margin-bottom: 30px">
                    Soll das Space: <span style="font-weight: bold">{{this.spaceToCopy.name}}</span>
                    wirklich
                    kopiert werden?
                </div>
                <AdaButton :loading="copyingTemplate" class="btn-delete" @click="copyClicked" title="KOPIEREN"
                           type="createButton"></AdaButton>
            </div>
        </Dialog>
    </div>
</template>

<script>

    import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
    import TabList from "../../../components/tablist/TabList";
    import AdaDatatable from "../../../components/tables/AdaDatatable";
    import InputSearch from "../../../components/inputs/InputSearch";
    import AdaButton from "../../../components/buttons/AdaButton";
    import Transformers from "../../../components/tables/Transformers";
    import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
    import Dialog from "../../../components/dialog/Dialog";

    const SpacesRepository = RepositoryFactory.get('spaces');

    export default {
        components: {
            TabList,
            BreadCrumb,
            AdaDatatable,
            InputSearch,
            AdaButton,
            Dialog
        },
        data: function () {
            return {
                spaceToDelete: null,
                spaceToCopy: null,
                showDeleteSpaceDialog: false,
                showCopySpaceDialog: false,
                searchValue: '',
                columns: [
                    {
                        viewName: 'Space',
                        propName: 'name',
                        sortable: true,
                        width: '35%'
                    },
                    {
                        viewName: 'Technischer Name',
                        propName: 'technical_name',
                        sortable: true,
                        width: '35%'
                    },
                    {
                        viewName: 'Erstellungsdatum',
                        propName: 'created_at',
                        sortable: true,
                        width: '15%'
                    },
                    {
                        viewName: 'Aktion',
                        propName: 'action',
                        width: '15%'
                    }
                ],
                items: [
                    {
                        name: 'Tracking-Listen',
                        link: '/templates/trackinglists'
                    },
                    {
                        name: 'Spaces',
                        link: '/templates/spaces'
                    },
                    {
                        name: 'Module',
                        link: '/templates/modules'
                    },
                    {
                        name: 'Interaktionen',
                        link: '/templates/interactions'
                    }
                ],
                activeItemName: 'Spaces',
                transformers: [
                    {
                        propName: 'action',
                        transform: function (value) {
                            let res = '';
                            value.forEach(action => {
                                switch (action) {
                                    case 'edit':
                                        res += '<span data-type="edit" class="margin-right hover-highlight icon icon-edit"></span>';
                                        break;
                                    case 'copy':
                                        res += '<span data-type="duplicate" class="margin-right hover-highlight icon icon-duplicate"></span>';
                                        break;
                                    case 'delete':
                                        res += '<span data-type="delete" class="margin-right hover-highlight icon icon-delete"></span>';
                                        break;
                                }
                            });
                            return res;
                        }
                    },
                    {
                        propName: 'created_at',
                        transform: Transformers.dateTransformer
                    }
                ],
                loading: true,
                copyingTemplate: false,
                deletingTemplate: false,
            }
        },
        name: "TemplateSpaces",
        mounted() {
            this.fetchSpaces();
        },
        computed: {
            spaceTemplates() {
                return this.$store.state.spaces.templateSpaces;
            },
        },
        methods: {
            async fetchCopySpace() {
                try {
                    await SpacesRepository.copySpace(this.spaceToCopy.id);
                    this.$noty.success('Spacevorlage erfolgreich kopiert.');
                    this.spaceToCopy = null;
                    this.showCopySpaceDialog = false;
                    this.loading = true;
                    this.fetchSpaces();
                } catch (e) {
                    console.error(e);
                    this.$noty.error('Spacevorlage konnte nicht kopiert werden.');
                }
                this.copyingTemplate = false;
            },
            copyClicked() {
                this.copyingTemplate = true;
                this.fetchCopySpace();
            },
            copyDialogClose() {
                this.showCopySpaceDialog = false;
            },
            deleteDialogClose: function () {
                this.showDeleteSpaceDialog = false;
                this.spaceToDelete = null;
            },
            deleteClicked() {
                this.deletingTemplate = true;
                this.deleteSpaceTemplate(this.spaceToDelete.id);
            },
            cellClicked: function (data) {
                let dataType = data.target.getAttribute('data-type');
                switch (dataType) {
                    case 'edit':
                        this.$router.push({name: 'editspacetemplate', params: {id: data.row.id}});
                        break;
                    case 'duplicate':
                        this.spaceToCopy = data.row;
                        this.showCopySpaceDialog = true;
                        break;
                    case 'delete':
                        this.showDeleteSpaceDialog = true;
                        this.spaceToDelete = data.row;
                        break;
                    case 'dashboard':
                        this.$router.push({name: 'showDashboard', params: {id: data.row.id}});
                        break;
                    default:
                        this.$router.push({name: 'editspacetemplate', params: {id: data.row.id}});
                        break;
                }
            },
            async fetchSpaces() {
                await this.$store.dispatch('spaces/fetchTemplateSpaces', true);
                this.loading = false;
            },
            async deleteSpaceTemplate(id) {
                try {
                    await SpacesRepository.deleteSpace(id);
                    this.$noty.success("Der Space wurde erfolgreich gelöscht.");
                } catch (e) {
                    console.error(e);
                    this.$noty.error("Fehler beim Löschen des Spaces.");
                }
                this.deletingTemplate = false;
                this.showDeleteSpaceDialog = false;
                this.fetchSpaces();
                this.loading = true;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .spaces-filter-container {
        width: 100%;
        background-color: white;
        height: 50px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 12px;
    }

    .tab-list {
        margin-bottom: 20px;
    }

    .loader {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        width: 100%;
    }

    .btn-delete{
        width: fit-content;
    }

    h4{
        margin-top: 0;
    }

    ::v-deep .ada-table-container tr {
        display: flex;
    }

    ::v-deep .ada-table-container td {
        display: block;
    }

</style>